import React from 'react';
import './FeatureBar.css';
import { getAllFeatures } from './FeatureManager';

const ICONS = {
  animated_design: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="1" y="3" width="10" height="10" rx="1.5"/>
      <path d="M11 6.5l4-2v7l-4-2"/>
    </svg>
  ),
  ghost_mannequin: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M8 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/>
      <path d="M4 14c0-2.2 1.8-4 4-4s4 1.8 4 4"/>
      <rect x="3" y="6" width="10" height="5" rx="1" strokeDasharray="2 1.5"/>
    </svg>
  ),
  product_staging: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="1" y="5" width="14" height="9" rx="1.5"/>
      <path d="M4 5V4a4 4 0 0 1 8 0v1"/>
      <circle cx="8" cy="9.5" r="1.5"/>
    </svg>
  ),
  virtual_models: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <circle cx="8" cy="5" r="2.5"/>
      <path d="M3 14c0-2.8 2.2-5 5-5s5 2.2 5 5"/>
    </svg>
  ),
  ai_backgrounds: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="1" y="1" width="14" height="14" rx="2"/>
      <path d="M1 6h14M6 6v8"/>
      <circle cx="10.5" cy="10.5" r="2"/>
    </svg>
  ),
  flat_lay: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="1" y="4" width="14" height="9" rx="1.5"/>
      <circle cx="8" cy="8.5" r="2.5"/>
      <path d="M5 4V3M11 4V3"/>
    </svg>
  ),
};

const DEFAULT_ICON = 'animated_design';

export default function FeatureBar({ activeFeature, onFeatureChange, onManage }) {
  // getAllFeatures() inclut BASE_FEATURES + custom features créées dans Feature Manager
  const features = getAllFeatures();

  return (
    <div className="feature-bar">
      {features.map(f => (
        <div
          key={f.id}
          className={`feature-bar-item${activeFeature === f.id ? ' active' : ''}`}
          onClick={() => onFeatureChange && onFeatureChange(f.id)}
          title={f.name}
        >
          <span className="feature-bar-icon">
            {ICONS[f.icon] || ICONS[f.id] || ICONS[DEFAULT_ICON]}
          </span>
          <span className="feature-bar-label">{f.name}</span>
        </div>
      ))}
      <div className="feature-bar-add-wrap">
        <button className="feature-bar-add-btn" onClick={() => onManage && onManage()}>
          Feature Manager
        </button>
      </div>
    </div>
  );
}
